import React from "react";

import ProgressOptions from "../progressOptions";
import StepperHeader   from "../stepperHeader";

import useStyles from "./styles";

const StepOne = ( { type, monetisationData, toggleFeedback, currentStep, totalSteps, stepData, seperatorText } ) => {

	const { classes }                  = useStyles ( undefined, { name: "styles" } );
	const { title, options, options1 } = stepData;

	return (
		<div className = { classes.stepOneWrapper }>

			<StepperHeader
				currentStep       = { currentStep }
				title             = { title }
				totalSteps        = { totalSteps }
			/>

			<ProgressOptions
				options       = { options }
				options1      = { options1 }
				seperatorText = { seperatorText }
			/>

		</div>

	);
};

export default StepOne;